import React from 'react';
import moment from 'moment';
import styled from 'styled-components';
import { useField, connect } from 'formik';
import { TimePicker } from 'datepicker-wrap';

import Error from '../components/Error';
import { FormLabel as Label } from '~ui-kit';
import FieldContextFeeder from '../components/FieldContextFeeder';

const noPastDateFilter = date => {
  return !moment(date).isBefore(moment(), 'day');
};

const noPastTimeFilter = time => {
  return moment(time).isAfter(moment());
};

const TimeField = props => {
  const [field, meta] = useField(props);
  const error = meta.touched && meta.error;
  const { setFieldValue } = props.formik;

  const name = props.id || props.name;

  const handleTimeChange = date => {
    setFieldValue(name, date);
  };

  const additionalProps = {};
  if (props.noPastDate) additionalProps.filterDate = noPastDateFilter;
  if (props.noPastTime) additionalProps.filterTime = noPastTimeFilter;

  return (
    <Wrapper>
      <Aligner row={props.row}>
        <Label
          htmlFor={props.id || props.name}
          info={props.info}
          required={props.required}
        >
          {props.label}
        </Label>
        <Container>
          <TimePicker
            {...additionalProps}
            selected={field.value}
            onChange={handleTimeChange}
            timeIntervals={props.timeIntervals}
          />
        </Container>
      </Aligner>
      {error ? (
        <ErrorWrapper>
          <Error>{meta.error}</Error>
        </ErrorWrapper>
      ) : null}
    </Wrapper>
  );
};

const Aligner = styled.div`
  ${p =>
    p.row &&
    `
    display: flex;
    align-items: center;
    & > label {
      margin: 0 12px 0 0;
    }
  `}
`;

const Container = styled.div`
  display: flex;
  align-items: center;
`;

const Wrapper = styled.div``;

const ErrorWrapper = styled.div`
  margin-top: 12px;
`;

export default FieldContextFeeder(connect(TimeField));
